export const desktopQuery = 'screen and (min-width: 1280px)';
export const tabletQuery = 'screen and (max-width: 1279px) and (min-width: 768px)';
export const mobileQuery = 'screen and (max-width: 767px)';

export const isDesktopWidth = () =>
    !__SERVER__ && window && window.matchMedia(desktopQuery).matches;

export const isTabletWidth = () => !__SERVER__ && window && window.matchMedia(tabletQuery).matches;

export const isMobileWidth = () => !__SERVER__ && window && window.matchMedia(mobileQuery).matches;
